import React from 'react'
import { useStyles } from './styles.js'

const RightArrow = () => {
  const classes = useStyles()
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="8.13"
      height="14.441"
      viewBox="0 0 8.13 14.441"
    >
      <defs>{/* <style>.a{fill:#4a4a4a;}</style> */}</defs>
      <path
        class="a"
        fill="#9F9E9E"
        d="M-449.774,13.368l-6.734-6.734a.754.754,0,0,0-1.065,0h0a.754.754,0,0,0,0,1.065l5.935,5.935-5.935,5.935a.754.754,0,0,0,0,1.065h0a.754.754,0,0,0,1.065,0l6.734-6.734A.376.376,0,0,0-449.774,13.368Z"
        transform="translate(457.793 -6.415)"
      />
    </svg>
  )
}
export default RightArrow
